import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './store/store';
import { MsalProvider } from '@azure/msal-react';
import { MsalInstanceProvider } from './store/auth/msal-instance-provider';

const msalInstance = MsalInstanceProvider.getInstance();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

msalInstance.initialize().then(() => {
  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <Provider store={store}>
          <App />
        </Provider>
      </MsalProvider>
    </React.StrictMode>
  );
});
